module.exports = __webpack_public_path__ + "img/flying_saucer.c373ae0b.gif";